/* Owl Village: each section's foreground arrives as one calm layer. */
(() => {
  'use strict';

  const instances = new Map();
  const decoration = 'svg, .ov-village-trail, .ov-belief-waves, .ov-ribbon-ford, script, style';

  function mount(root) {
    if (instances.has(root) || typeof IntersectionObserver !== 'function') return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motion.matches) return;

    // Keep the hero's existing entrance. Observe sections, never individual cards.
    // Animate only their foreground children: the scenery is a separate sibling.
    const groups = [...root.children]
      .filter(section => section.matches('section, .hd-river, .hd-social-footer') && !section.matches('.hero'))
      .map(section => ({ section, content: [...section.children].filter(child => !child.matches(decoration)) }))
      .filter(group => group.content.length);
    if (!groups.length) return;

    let observer;
    function reveal(section, instant = false) {
      if (instant) section.classList.add('is-ov-instant');
      section.classList.add('is-ov-visible');
      observer?.unobserve(section);
    }
    function onFocus(event) {
      const section = event.target.closest('.ov-reveal-section');
      if (section && root.contains(section)) reveal(section, true);
    }
    function onMotion(event) {
      if (event.matches) groups.forEach(({ section }) => reveal(section, true));
    }
    function dispose() {
      observer?.disconnect();
      root.removeEventListener('focusin', onFocus);
      motion.removeEventListener('change', onMotion);
      root.classList.remove('ov-content-reveal-ready');
      groups.forEach(({ section, content }) => {
        section.classList.remove('ov-reveal-section', 'is-ov-visible', 'is-ov-instant');
        content.forEach(child => child.classList.remove('ov-reveal-content'));
      });
      instances.delete(root);
    }

    try {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -64px 0px' });

      groups.forEach(({ section, content }) => {
        section.classList.add('ov-reveal-section');
        content.forEach(child => child.classList.add('ov-reveal-content'));
        // Already visible content and anchor destinations must never flash away.
        if (section.getBoundingClientRect().top < window.innerHeight || section.contains(document.activeElement)) {
          reveal(section, true);
        } else {
          observer.observe(section);
        }
      });
      root.addEventListener('focusin', onFocus);
      motion.addEventListener('change', onMotion);
      root.classList.add('ov-content-reveal-ready');
      instances.set(root, dispose);
    } catch (_) {
      // Progressive enhancement: any setup failure leaves all content visible.
      dispose();
    }
  }

  function boot() {
    document.querySelectorAll('.ov-homepage.ov-hadley--a').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => {
      if (event.target.contains(root)) dispose();
    });
  });
})();
